export function HttpIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13.275 4.038a1 1 0 01.686 1.237l-4 14a1 1 0 11-1.923-.55l4-14a1 1 0 011.237-.687zM6 9a1 1 0 100-2 1 1 0 000 2zM6 14a1 1 0 100-2 1 1 0 000 2zM18.962 5.275a1 1 0 10-1.924-.55l-4 14a1 1 0 101.923.55l4-14z"
      ></path>
    </svg>
  );
}
